export const API_URL = 'https://dev.gissewingmachine.com/api/imagenes-producto/';